import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const saveProductivityDashboardView = {
  name: "saveProductivityDashboardView" as const,
  input: z.object({ view: viewSchemas["productivity-dashboard"] }),
  output: z.object({}),
};
